import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import {
  COOPERATION_DETAIL,
  COOPERATION_APPROVE,
  COOPERATION_DETAIL_LOG,
  COOPERATION_REGIST,
  COOPERATION_COUNTUP
} from 'manager/http-constants';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { CONSTANT } from 'src/app/shared/constant/constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { DATE_FORMAT } from 'src/app/shared/constant/constant';
import { PlatformComponent } from '../platform.component';
import { ApprovalDialogComponent } from '../common/approval-dialog/approval-dialog.component';
import { DiffTableComponent } from '../common/diff-table/diff-table.component';
import { INPUT_INFORMATIONS_API_CONSTANT } from 'src/app/shared/constant/api-constant';
import { Validator } from 'src/app/shared/validator/validator';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-h301',
  templateUrl: './h301.component.html',
  styleUrls: ['./h301.component.scss', '../platform.component.scss'],
})

/**
 * 連携事例詳細
 */
export class H301Component extends PlatformComponent {
  /** 共通部品_承認時ダイアログ */
  @ViewChild(ApprovalDialogComponent)
  approvalDialogComponent: ApprovalDialogComponent;

  /** 共通部品_差分比較 */
  @ViewChild(DiffTableComponent)
  diffTableComponent: DiffTableComponent;

  // 入力フォーム 入力値チェック用
  h101InputForm: FormGroup = this.formBuilder.group({
    // タイトル
    title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'title',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 取組概要
    attemptoverview: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'attemptoverview',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 事例イメージ１
    case_image1: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'case_image1',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 事例イメージ１キャプション
    case_image1_caption: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'case_image1_caption',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 事例イメージ２
    case_image2: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'case_image2',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 事例イメージ１キャプション
    case_image2_caption: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'case_image2_caption',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 都道府県
    prefectures: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'prefectures',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 地上公共団体等代表
    public_representative: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'public_representative',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 民間団体等代表
    private_representatibe: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'private_representatibe',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 他連携団体等
    other_cooperation: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'other_cooperation',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 事例タグ
    case_tag: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'case_tag',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // カテゴリ
    category: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'category',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // 事業費
    business_cost: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'business_cost',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 目指すSDGsゴール
    sdgs_goal: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'sdgs_goal',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // 連携開始時期
    coopstart_season: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'coopstart_season',
          INPUT_INFORMATIONS_API_CONSTANT.DATE_TYPE
        ),
      ],
    }),
    // この取組で解決した課題
    clear_agenda: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'clear_agenda',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 解決に向けた手法
    method: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'method',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 概要イメージ１
    overview_image1: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'overview_image1',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 概要イメージ１キャプション
    overview_image1_caption: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'overview_image1_caption',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 概要イメージ２
    overview_image2: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'overview_image2',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 概要イメージ２キャプション
    overview_image2_caption: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'overview_image2_caption',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 事業推進上の各団体の役割分担
    role_sharing: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'role_sharing',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 地域関係者との連携方法
    coop_method: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'coop_method',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 資金調達方法
    funding_plan: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'funding_plan',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 資金調達方法の補足
    funding_plan_supplement: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'funding_plan_supplement',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 事業推進上の困難・課題・解決方法
    solution: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'solution',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 担当者のコメント
    responsible_person_comment: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'responsible_person_comment',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 担当者写真
    responsible_person_image: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'responsible_person_image',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 担当者キャプション
    responsible_person_caption: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'responsible_person_caption',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 公開設定
    cooperation_open: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'cooperation_open',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 団体名
    organization_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'organization_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 部署名
    divition_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'divition_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 担当者名
    responsible_person_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'responsible_person_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 電話番号
    tel: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'tel',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // メールアドレス
    email: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'email',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 地方創生SDGsの視点
    sdgs_perspective: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'sdgs_perspective',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // ステークホルダーとの連携
    coop_stakeholders: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'coop_stakeholders',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // モデル性・波及性
    model_nature: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'cooperation',
          'model_nature',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
  });

  // 連携事例ID
  cooperationId: string = this.route.snapshot.params.cooperation_id;

  // 連携事例詳細格納先
  detailCooperation: any;

  // 一時保存フラグ
  tempSaveFlg: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData,
    private location: Location,
    private datePipe: DatePipe,
    private loginService: LoginService,
    private titleService: Title
  ) {
    super(route, commonService, dbOperationService, loadingState);
    this.titleService.setTitle('地方創生SDGs官民連携マッチングシステム｜内閣府');
  }

  // 取得辞書マスタコード
  getSpecCode: any = [3,2017,2018,];

  async ngOnInit(): Promise<void> {

    await this.getUserLogin();
    // 辞書値リストを取得
    this.getSpecCodeList(this.getSpecCode);

    // 連携事例詳細を取得
    this.getDetailCooperation();
  }

  /**
   * 連携事例詳細を取得
   */
  public getDetailCooperation(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(COOPERATION_DETAIL);

    // 連携事例詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(COOPERATION_DETAIL, this.cooperationId, true)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, COOPERATION_DETAIL);

        if (this.commonService.checkNoneResponse(response)) {
          // 警告メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.WARN,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E00026),
            })
          );

          // 前画面へ戻る
          this.location.back();
        } else {
          // 連携事例詳細を格納
          this.detailCooperation = response.body;

          // let pageTitle = detailCooperation public_representative
          this.titleService.setTitle(`${this.detailCooperation.title} (${this.detailCooperation.public_representative} × ${this.detailCooperation.private_representatibe}) | 官⺠連携事例`);

          if(!this.decisionPerspective(this.detailCooperation.member_id) &&
            !this.decisionSecretariat() && this.detailCooperation.status.id != '2'
          ){
            // 異常メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
                position: TOAST.BOTTOM_RIGHT,
                life: 60000,
              })
            );
            this.loginService.logout(MESSAGE_CODE.N90001);
            return;
          }

          // 連携事例カウントアップ
          this.countUp();

          // 一時保存フラグを判定する
          this.checkTempSave();
        }
      });
  }

  /**
   * 一時保存中かどうかを判定する
   */
  public checkTempSave(): void {
    // 初期値セット
    this.commonService.setFormGroupInitialData(
      this.h101InputForm,
      this.detailCooperation
    );
    // ※値渡し
    let h101InputForm: any = JSON.parse(
      JSON.stringify(this.h101InputForm.value)
    );
    // 登録前変換
    {
      // 配列をカンマ区切り変換
      // 関連するゴール
      h101InputForm.sdgs_goal = h101InputForm.sdgs_goal.toString();
      // カテゴリ
      h101InputForm.category = h101InputForm.category.toString();
      // 事例タグ
      h101InputForm.case_tag = h101InputForm.case_tag.toString();
    }
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart("multiValidationResult");
    /* 共通バリデーションチェック */
    this.dbOperationService.multiValidationResult(
      'cooperation',
      h101InputForm,
    ).subscribe((response) => {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, "multiValidationResult");
      if(response.body[0].result != "0"){
        this.tempSaveFlg = true;
      }
    });
  }

  /**
   * 連携事例登録(H101)へ遷移する
   */
  public moveH101(): void {
    // 連携事例登録(H101)へ遷移
    this.router.navigate(['pages/platform/h101/edit'], {
      queryParams: {
        screenId: 'h101',
        cooperation_id: this.route.snapshot.params.cooperation_id,
      },
    });
  }

  /**
   * 公開判定フラグ
   * @returns 0:表示なし 1:公開中 2:非公開
   */
  public releaseFlag(): number {
    // 連携事例詳細の判定
    if (!this.detailCooperation) {
      // 連携事例詳細が存在しない場合

      return 0;
    }

    // 課題記載ユーザ or 事務局ユーザーか否か
    if (
      this.decisionPerspective(this.detailCooperation.member_id) ||
      this.decisionSecretariat()
    ) {
      // 課題記載ユーザ or 事務局ユーザーの場合

      // 掲載終了日の判定
      if (
        this.datePipe.transform(new Date(), DATE_FORMAT.DATE) <=
        this.datePipe.transform(
          new Date(this.detailCooperation?.end_date),
          DATE_FORMAT.DATE
        )
      ) {
        // 掲載終了日より前の場合

        return 1;
      } else {
        // 掲載終了日より後の場合

        return 2;
      }
    }

    return 0;
  }

  /**
   * 内閣府承認ダイアログ表示
   */
  public openSmallApprovalDialog(): void {
    // 内閣府承認ダイアログ表示
    this.approvalDialogComponent.openSmallApprovalDialog(
      COOPERATION_APPROVE,
      this.cooperationId,
      2020,
      0,
      1
    );
  }

  /**
   * 連携事例検索(H201)へ遷移する
   *
   */
  public moveH201(): void {
    //連携事例検索(H201)へ遷移する
    this.router.navigate(['pages/platform/h201']);
  }

  /**
   * 連携事例登録完了(H103)へ遷移する
   */
  public moveH103(): void {
    //連携事例登録完了(H103)へ遷移する
    this.router.navigate(['pages/platform/h103']);
  }

  /**
   * 値NULL判定
   */
  public checkNull(val: any): any {
    if(val == null || typeof val === 'undefined' || !Object.keys(val).length){
      return true;
    }
    return false;
  }

  /**
   * プリントプレビュー画面を表示
   */
  public print(): void {
    window.print();
  }

  /**
   * 差分ダイアログ表示
   */
  public openDiffDialog(screen_id: string): void {
    // 差分比較ダイアログ表示
    this.diffTableComponent.openDiffTable(
      screen_id,
      COOPERATION_DETAIL,
      COOPERATION_DETAIL_LOG,
      this.cooperationId,
      2019,
      0
    );
  }

  /**
  * 登録
  */
  public regist(): void {

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(COOPERATION_DETAIL);

    // 登録
    this.dbOperationService
      .updateData(COOPERATION_REGIST, this.cooperationId)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, COOPERATION_DETAIL);

        // レスポンス結果を判定
        if (this.commonService.checkNoneResponse(response)) {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );
        } else {
          // 正常終了の場合

          // 登録完了
          this.moveH103();
        }
      });
  }

  /**
   * 画面サイズ設定
   */
  public setImageSize(domId: string): void {
    let dom = document.getElementById(domId);
    if(dom.offsetHeight < dom.offsetWidth){
      dom.style.width = "100%";
      dom.style.height = "auto";
      dom.style.position = "absolute";
      dom.style.objectFit = "contain";

    } else {
      dom.style.width = "auto";
      dom.style.height = "100%";
      dom.style.position = "absolute";
      dom.style.objectFit = "contain";
    }
  }

  /**
   * カウントアップ
   */
  public countUp(): void {

    // 課題記載ユーザ or 事務局ユーザーか否か
    if (
      this.decisionPerspective(this.detailCooperation.member_id) ||
      this.decisionSecretariat()
    ) {
    } else {
      this.dbOperationService
        .countUpCooperation(COOPERATION_COUNTUP, this.cooperationId)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, COOPERATION_DETAIL);

          // レスポンス結果を判定
          if (this.commonService.checkNoneResponse(response)) {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );
          }
        });
    }
  }

  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });
  }
}
